"use strict";

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.colour = void 0;

var _createMuiTheme = _interopRequireDefault(require("@material-ui/core/styles/createMuiTheme"));

var _ColourUtils = require("./utils/ColourUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var colour = {
  black: "#000000",
  blue100: "#1976D2",
  blue200: "#E2ECF5",
  blue300: "#DDEBF9",
  blue400: "#BCD8F2",
  green: "green",
  grey100: "#374953",
  grey200: "#62757F",
  grey300: "#90A4AE",
  grey400: "#97A3AA",
  grey500: "#E7EBEF",
  grey600: "#E5E7E8",
  grey700: "#E2E4E6",
  grey800: "#FEFEFE",
  red100: "#CC2029",
  yellow100: "#FFCE00",
  yellow200: "#FFD21A",
  yellow300: "#FFD526",
  white: "#FFFFFF"
};
exports.colour = colour;
var theme = (0, _createMuiTheme["default"])({
  palette: {
    text: {
      primary: colour.grey100
    },
    background: {
      "default": colour.grey800
    },
    info: {
      main: colour.blue100
    }
  },
  typography: {
    fontFamily: "Archivo, Helvetica, Arial, sans-serif"
  },
  custom: {
    yellowGradient: "linear-gradient(to right, #FFAB3B, #FFB501 8%, ".concat(colour.yellow100, " 84%, #FFE17C)"),
    colour: colour
  },
  overrides: {
    MuiAutocomplete: {
      input: {
        height: 41
      },
      inputRoot: {
        paddingRight: 10
      }
    },
    MuiBreadcrumbs: {
      root: {
        paddingBottom: 0
      },
      ol: {
        flexWrap: "nowrap"
      },
      li: {
        fontSize: 14,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        "&>p,a": {
          height: 15,
          lineHeight: "15px",
          paddingBottom: 0
        }
      }
    },
    MuiButton: {
      root: {
        whiteSpace: "nowrap",
        height: 44,
        "&.Mui-disabled": {
          backgroundColor: colour.grey300,
          border: "solid 1px ".concat(colour.grey300),
          color: colour.grey300
        },
        "&:hover": {
          backgroundColor: colour.grey600,
          border: "solid 1px ".concat(colour.grey300),
          color: colour.white,
          "@media (hover: none)": {
            backgroundColor: colour.grey600
          }
        },
        "& *.MuiTouchRipple-child": {
          color: colour.grey300
        }
      },
      sizeSmall: {
        height: 32
      },
      sizeLarge: {
        height: 50
      },
      textPrimary: {
        color: colour.black,
        backgroundColor: colour.yellow100,
        "&.Mui-disabled": {
          backgroundColor: colour.grey400,
          border: "none",
          color: colour.grey500
        },
        "&:hover": {
          backgroundColor: colour.yellow200,
          border: "none",
          color: colour.black,
          "@media (hover: none)": {
            backgroundColor: colour.yellow200
          }
        },
        "& *.MuiTouchRipple-child": {
          backgroundColor: colour.yellow300
        }
      },
      textSecondary: {
        color: colour.grey100,
        border: "solid 1px ".concat(colour.grey300),
        backgroundColor: colour.white,
        "&.Mui-disabled": {
          backgroundColor: colour.white,
          border: "solid 1px ".concat(colour.grey400),
          color: colour.grey500
        },
        "&:hover": {
          backgroundColor: colour.grey600,
          color: colour.grey100,
          "@media (hover: none)": {
            backgroundColor: colour.grey600
          }
        },
        "& *.MuiTouchRipple-child": {
          backgroundColor: colour.grey600,
          color: colour.grey100
        }
      },
      label: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: "24px",
        textTransform: "none"
      },
      outlinedSecondary: {
        border: "1px solid ".concat(colour.white),
        color: colour.white,
        "&:hover": {
          borderColor: colour.white,
          color: colour.white
        },
        "& *.MuiTouchRipple-child": {
          backgroundColor: colour.white,
          color: colour.grey100
        }
      }
    },
    MuiCard: {
      root: {
        overflow: "visible",
        boxShadow: "0 2px 10px 0 ".concat((0, _ColourUtils.alphaColour)(colour.black, 12)),
        "&:hover": {
          boxShadow: "0 4px 8px -1px ".concat((0, _ColourUtils.alphaColour)(colour.black, 10), ",                      0 12px 40px 0 ").concat((0, _ColourUtils.alphaColour)(colour.black, 14)),
          cursor: "pointer"
        }
      }
    },
    MuiCardContent: {
      root: {
        padding: "0px 16px",
        "&:last-child": {
          paddingBottom: 8
        }
      }
    },
    MuiCardHeader: {
      root: {
        paddingTop: 0,
        paddingBottom: 0
      }
    },
    MuiDivider: {
      root: {
        backgroundColor: colour.grey500
      }
    },
    MuiExpansionPanel: {
      root: {
        margin: 0,
        padding: "4px 0",
        boxShadow: "none",
        backgroundColor: "inherit",
        borderBottom: "solid 1px ".concat(colour.grey500),
        "&:before": {
          height: 0
        },
        "&$expanded": {
          margin: 0
        }
      },
      rounded: {
        borderRadius: 0,
        "&:first-child": {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0
        },
        "&:last-child": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },
    MuiExpansionPanelDetails: {
      root: {
        padding: 0
      }
    },
    MuiExpansionPanelSummary: {
      root: {
        padding: 0,
        "&$expanded": {
          minHeight: 48
        }
      },
      content: {
        fontWeight: "bolder",
        "&$expanded": {
          margin: 0
        }
      }
    },
    MuiFilledInput: {
      root: {
        backgroundColor: "".concat((0, _ColourUtils.alphaColour)(colour.blue100, 6)),
        borderBottomLeftRadius: 18,
        borderBottomRightRadius: 18,
        borderTopLeftRadius: 18,
        borderTopRightRadius: 18
      }
    },
    MuiIconButton: {
      root: {
        "& *.MuiTouchRipple-root": {
          color: colour.white
        },
        "&.Mui-disabled": {
          border: "solid 1px ".concat(colour.grey400),
          color: colour.grey300,
          backgroundColor: colour.white
        },
        "&:hover": {
          borderColor: colour.blue100
        },
        "& .MuiOutlinedInput-root": {
          "&:hover fieldset": {
            borderColor: colour.blue100
          },
          "&.Mui-focused fieldset": {
            borderColor: colour.blue100
          }
        }
      },
      colorPrimary: {
        border: "solid 1px ".concat(colour.grey300),
        color: colour.grey100,
        width: 44,
        height: 44,
        padding: 10,
        "&:hover": {
          backgroundColor: colour.grey400
        }
      }
    },
    MuiList: {
      root: {
        listStyle: "disc",
        paddingInlineStart: "20px"
      }
    },
    MuiListItem: {
      root: {
        fontSize: 14,
        paddingBottom: 0,
        paddingTop: 0
      }
    },
    MuiMenu: {
      list: {
        paddingInlineStart: 0
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: 14,
        minHeight: 34,
        paddingLeft: 16,
        paddingBottom: 0,
        paddingTop: 0
      }
    },
    MuiOutlinedInput: {
      root: {
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: colour.blue100
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderWidth: 1
        }
      }
    },
    MuiPaper: {
      elevation1: {
        boxShadow: "0 2px 10px 0 ".concat((0, _ColourUtils.alphaColour)(colour.black, 12))
      }
    },
    MuiRating: {
      sizeLarge: {
        fontSize: 32,
        top: 5
      },
      sizeSmall: {
        fontSize: 18,
        top: 2
      }
    },
    MuiSelect: {
      root: {
        fontSize: 14,
        lineHeight: "21px"
      },
      select: {
        "&:focus": {
          borderRadius: 18
        }
      },
      filled: {
        backgroundColor: "".concat((0, _ColourUtils.alphaColour)(colour.blue100, 6)),
        borderRadius: 18,
        border: "1px solid ".concat(colour.blue400),
        color: colour.blue100,
        padding: "5px 30px 5px 8px"
      },
      iconFilled: {
        color: colour.blue100
      }
    },
    MuiSvgIcon: {
      root: {
        position: "relative"
      },
      colorPrimary: {
        color: colour.grey100
      },
      colorSecondary: {
        color: colour.grey200
      },
      fontSizeSmall: {
        fontSize: 14,
        top: 3,
        width: 20,
        height: 20
      },
      fontSizeLarge: {
        fontSize: 32
      },
      colorAction: {
        color: colour.blue100
      },
      colorError: {
        color: colour.red100
      }
    },
    MuiTableRow: {
      root: {
        "&:hover": {
          backgroundColor: colour.yellow100
        },
        cursor: "pointer"
      },
      head: {
        "&:hover": {
          backgroundColor: "transparent"
        },
        cursor: "default"
      }
    },
    MuiTextField: {
      root: {
        border: "1px solid",
        borderColor: colour.grey500,
        borderRadius: 4,
        "&:hover": {
          borderColor: colour.blue100
        },
        "&:focus-within": {
          borderColor: colour.blue100
        }
      }
    },
    MuiTypography: {
      colorPrimary: {
        color: colour.grey100
      },
      colorSecondary: {
        color: colour.grey200
      },
      colorTextPrimary: {
        color: colour.blue100
      },
      colorTextSecondary: {
        color: colour.black
      },
      h1: {
        fontSize: 26,
        fontWeight: 700,
        lineHeight: "36px",
        paddingTop: 48,
        paddingBottom: 16
      },
      h2: {
        fontSize: 22,
        fontWeight: 700,
        lineHeight: "32px",
        paddingTop: 16,
        paddingBottom: 8
      },
      h3: {
        fontSize: 18,
        fontWeight: 700,
        lineHeight: "24px",
        paddingTop: 12,
        paddingBottom: 4
      },
      subtitle1: {
        fontSize: 18,
        fontWeight: 400,
        lineHeight: "24px",
        paddingTop: 12,
        paddingBottom: 4
      },
      subtitle2: {
        fontSize: 14,
        lineHeight: "21px",
        fontWeight: 700,
        paddingTop: 8,
        paddingBottom: 8
      },
      body1: {
        fontSize: 16,
        fontWeight: 400,
        lineHeight: "24px",
        paddingTop: 0,
        paddingBottom: 12
      },
      body2: {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: "21px",
        paddingTop: 0,
        paddingBottom: 8
      },
      overline: {
        fontSize: 12,
        lineHeight: "21px",
        fontWeight: 700
      }
    },
    MuiToggleButton: {
      root: {
        borderRadius: 18,
        color: colour.grey100,
        marginRight: 10,
        "&:last-child": {
          marginRight: 0
        },
        textTransform: "none",
        "&$selected": {
          backgroundColor: "".concat((0, _ColourUtils.alphaColour)(colour.blue100, 6)),
          border: "1px solid ".concat(colour.blue400),
          color: colour.blue100,
          "&:hover": {
            backgroundColor: "".concat((0, _ColourUtils.alphaColour)(colour.blue100, 6)),
            "@media (hover: none)": {
              backgroundColor: "".concat((0, _ColourUtils.alphaColour)(colour.blue100, 6))
            }
          },
          "& + &": {
            borderLeft: "1px solid ".concat(colour.blue400)
          }
        }
      },
      sizeSmall: {
        fontSize: 14,
        height: 32,
        padding: "1px 8px"
      },
      label: {
        lineHeight: "21px",
        minWidth: 120,
        whiteSpace: "nowrap"
      }
    },
    MuiToggleButtonGroup: {
      grouped: {
        "&:not(:first-child)": {
          borderLeft: "1px solid initial",
          borderTopLeftRadius: 18,
          borderBottomLeftRadius: 18
        },
        "&:not(:last-child)": {
          borderTopRightRadius: 18,
          borderBottomRightRadius: 18
        }
      }
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: colour.grey100
      },
      arrow: {
        color: colour.grey100
      }
    }
  }
}); // Extra breakpoint based styling

var breakpoints = theme.breakpoints,
    overrides = theme.overrides;
overrides.MuiBreadcrumbs.li[breakpoints.down("xs")] = {
  minWidth: 43
};
overrides.MuiButton.sizeLarge[breakpoints.down("sm")] = {
  minWidth: 50
};
var _default = theme;
exports["default"] = _default;